import React from 'react'
import { Flex, Box } from 'components/Box'
import games from '../Landing/Components/SelectaGame/SelectaGameContent'
import "react-multi-carousel/lib/styles.css";
import { InnerHeading, InnerParagraph, PlayButton, StyledCard } from 'views/Landing/Components/SelectaGame/SelectAGameStyled';
import { ArrowStyling, CardBody, CardFooter, CardFooterNotSelect } from './CarousalTopGmesStyled';

export const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4,
        slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};

const ButtonGroup = () => (<><div></div></>)

const GamesCarousal: React.FC = () => {

    return (
        <>
            <ArrowStyling
                swipeable={false}
                draggable={true}
                showDots={false}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                infinite={true}
                keyBoardControl={true}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
                renderButtonGroupOutside={true}
                customButtonGroup={<ButtonGroup />}
                arrows={true}
                autoPlay={false}
                customTransition="transform 1000ms linear"
                transitionDuration={1000}
                autoPlaySpeed={0}
                className='ArrowStyling'>
                {
                    games.map((game) => (
                        <Flex flexDirection='column' key={game.id}>
                            <CardBody>
                                <StyledCard>
                                    <Flex>
                                        <img src={game.image} alt='Games' />
                                    </Flex>
                                    <Box position='absolute'>
                                        <InnerHeading>{game.title}</InnerHeading>
                                        <InnerParagraph>{game.body}</InnerParagraph>
                                    </Box>

                                    {
                                        (game.enabled) ?
                                            <CardFooter to={game.url}>
                                                <PlayButton>{game.gamePlay}</PlayButton>
                                            </CardFooter>
                                            :
                                            <CardFooterNotSelect to={game.url}>
                                                <PlayButton>{game.gamePlay}</PlayButton>
                                            </CardFooterNotSelect>
                                    }

                                </StyledCard>
                            </CardBody>
                        </Flex>
                    ))
                }
            </ArrowStyling>
        </>
    )
}

export default GamesCarousal;